import { render } from "./TopMenuComponent.vue?vue&type=template&id=3a6fba1d"
import script from "./TopMenuComponent.vue?vue&type=script&lang=js"
export * from "./TopMenuComponent.vue?vue&type=script&lang=js"

import "./TopMenuComponent.vue?vue&type=style&index=0&id=3a6fba1d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__